<template>
  <b-card>
    <!-- form -->
    <b-form>
      <b-row v-if="tempUserData.acl !== 'mahasiswa'">
        <b-col md="12" class="mb-2">
          <h5>Data Personal</h5>
        </b-col>
        <b-col cols="12">
          <b-form-group
            label="NIP"
            label-for="nip"
          >
             <b-form-input
              id="nip"
              placeholder="NIP"
              v-model="tempUserData.nip"
              type="number"
            />
          </b-form-group>
        </b-col>
        <!-- bio -->
        <b-col cols="12">
          <b-form-group
            label="Alamat"
            label-for="alamat"
          >
            <b-form-textarea
              id="alamat"
              rows="2"
              placeholder="Alamat"
              v-model="tempUserData.alamat"
            />
          </b-form-group>
        </b-col>
        <!--/ bio -->

         <!-- phone -->
        <b-col md="6">
          <b-form-group
            label-for="Nomor Telepon"
            label="Nomor Telepon"
          >
            <cleave
              id="Nomor Telepon"
              class="form-control"
              :raw="false"
              :options="clevePhone"
              placeholder="Nomor Telepon"
              v-model="tempUserData.nomor_hp"
            />
          </b-form-group>
        </b-col>
        <!-- phone -->
        <b-col md="6">
          <b-form-group
            label="Tempat Lahir"
            label-for="tempat_lahir"
          >
             <b-form-input
              id="tempat_lahir"
              placeholder="Tempat Lahir"
              v-model="tempUserData.tempat_lahir"
            />
          </b-form-group>
        </b-col>
        <!-- birth date -->
        <b-col md="6">
          <b-form-group
            label-for="example-datepicker"
            label="Tanggal Lahir"
          >
            <flat-pickr
              class="form-control"
              name="date"
              placeholder="2023-01-01"
              v-model="tempUserData.tanggal_lahir"
            />
          </b-form-group>
        </b-col>
        <!--/ birth date -->

         <b-col md="6">
          <b-form-group
            label-for="gender"
            label="Jenis Kelamin"
          >
            <v-select
              id="gender"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="title"
              :reduce="val => val.value"
              :options="jenisKelaminOption.options"
              v-model="tempUserData.jenis_kelamin_id"
              placeholder="Pilih Jenis Kelamin"
            />
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group
            label-for="provinsi"
            label="Provinsi"
          >
            <v-select
              id="provinsi"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="title"
              :reduce="val => val.value"
               @input="(val) => changeKota(val)"
              :options="provinsiOption.options"
              v-model="tempUserData.provinsi_id"
              placeholder="Pilih Provinsi"
            />
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group
            label-for="kota"
            label="Kota"
          >
            <v-select
              id="kota"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="title"
              :reduce="val => val.value"
              :options="kotaOption.options"
              v-model="tempUserData.kota_id"
              placeholder="Pilih Kota"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <!-- ACL MAHASISWA -->
        <b-row v-if="tempUserData.acl === 'mahasiswa'">
          <b-col md="12" class="mt-2 mb-2">
            <h5>Data Kemahasiswaan</h5>
          </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Nama Lengkap <span style="color: red; font-size: 16px;">*</span></label>
                  <b-form-input
                    id="name"
                    v-model="tempUserData.name"
                    placeholder="Nama Lengkap"
                  />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Nama Ijazah <span style="color: red; font-size: 16px;">*</span></label>
                  <b-form-input
                    id="nama_ijazah"
                    v-model="tempUserData.nama_ijazah"
                    placeholder="Nama Ijazah"
                  />
              </b-form-group>
            </b-col>
             <b-col md="6">
              <b-form-group>
                <label for="">Asal SMA <span style="color: red; font-size: 16px;">*</span></label>
                  <b-form-input
                    id="asal_sma"
                    v-model="tempUserData.asal_sma"
                    placeholder="Asal SMA"
                  />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Jurusan SMA <span style="color: red; font-size: 16px;">*</span></label>
                  <v-select
                    id="gender"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="jurusanSMAOption.options"
                    v-model="tempUserData.jurusan_sma"
                    placeholder="Pilih Jurusan SMA"
                  />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">NPM <span style="color: red; font-size: 16px;">*</span></label>
                  <b-form-input
                    id="npm"
                    v-model="tempUserData.npm"
                    placeholder="NPM"
                    :maxlength="10"
                  />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Angkatan <span style="color: red; font-size: 16px;">*</span></label>
                  <b-form-input
                    id="angkatan"
                    v-model="tempUserData.angkatan"
                    placeholder="2023"
                    type="number"
                  />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Tempat Lahir <span style="color: red; font-size: 16px;">*</span></label>
                  <b-form-input
                    id="tempat_lahir"
                    v-model="tempUserData.tempat_lahir"
                    placeholder="Tempat Lahir"
                  />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Tanggal Lahir <span style="color: red; font-size: 16px;">*</span></label>
                  <b-form-datepicker v-model="tempUserData.tanggal_lahir" locale="id"></b-form-datepicker>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Alamat Mahasiswa <span style="color: red; font-size: 16px;">*</span></label>
                  <b-form-textarea
                  id="alamat"
                  v-model="tempUserData.alamat"
                  placeholder="alamat..."
                  rows="3"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
             <b-col md="6">
              <b-form-group>
                <label for="">Alamat Orang Tua <span style="color: red; font-size: 16px;">*</span></label>
                   <b-form-textarea
                  id="alamat"
                  v-model="tempUserData.alamat_orang_tua"
                  placeholder="alamat..."
                  rows="3"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Program <span style="color: red; font-size: 16px;">*</span></label>
                  <v-select
                    id="program"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="programOption.options"
                    v-model="tempUserData.program"
                    placeholder="Pilih Program"
                  />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Tahun Masuk <span style="color: red; font-size: 16px;">*</span></label>
                  <v-select
                    id="tahun_masuk"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="tahunOptions"
                    v-model="tempUserData.tahun_masuk"
                    placeholder="Pilih Tahun"
                  />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Pekerjaan Orang Tua <span style="color: red; font-size: 16px;">*</span></label>
                  <b-form-input
                    id="pekerjaan_orang_tua"
                    v-model="tempUserData.pekerjaan_orang_tua"
                    placeholder="Pekerjaan Orang Tua"
                  />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Jabatan Orang Tua <span style="color: red; font-size: 16px;">*</span></label>
                  <b-form-input
                    id="jabatan_orang_tua"
                    v-model="tempUserData.jabatan_orang_tua"
                    placeholder="Jabatan Orang Tua"
                  />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Nomor Telp <span style="color: red; font-size: 16px;">*</span></label>
                  <b-form-input
                    id="nomor_telp"
                    v-model="tempUserData.nomor_telp"
                    placeholder="Nomor Telpon Rumah"
                    type="number"
                  />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Nomor HP <span style="color: red; font-size: 16px;">*</span></label>
                  <b-form-input
                    id="nomor_hp"
                    v-model="tempUserData.nomor_hp"
                    placeholder="Nomor HP"
                    type="number"
                  />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Alamat Email UI <span style="color: red; font-size: 16px;">*</span></label>
                  <b-form-input
                    id="email"
                    v-model="tempUserData.alamat_email_ui"
                    type="email"
                    placeholder="john.doe@email.com"
                  />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="">Alamat Email Selain UI <span style="color: red; font-size: 16px;">*</span></label>
                  <b-form-input
                    id="email"
                    v-model="tempUserData.alamat_email_lain"
                    type="email"
                    placeholder="john.doe@email.com"
                  />
              </b-form-group>
            </b-col>
        </b-row>
        <!--END ACL MAHASISWA -->

        <b-row>
          <b-col cols="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mt-1 mr-1"
              @click="simpanData"
            >
              Simpan
            </b-button>
          </b-col>
        </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BCard, BFormTextarea, BFormDatepicker,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import Ripple from 'vue-ripple-directive'
import Cleave from 'vue-cleave-component'

// eslint-disable-next-line import/no-extraneous-dependencies
import 'cleave.js/dist/addons/cleave-phone.us'
import {
  getJenisKelamin,
  getJurusan,
  getJenjang,
  getProdi,
  getPeminatan,
  getProvinsi,
  getKota,
  ubahUserData,
  getJenisSidang,
  getProsesPersidangan,
  getDosen,
  postBerkas,
  updateBerkas,
  getPengajuanSidangDetail,
  uploadFilePengajuan,
  downloadDokumen,
  getRuangan,
  getProgram,
  getWaktuUjian,
  getJawabanPersetujuan,
} from '@/connection-api/master'

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BFormTextarea,
    vSelect,
    flatPickr,
    Cleave,
    BFormDatepicker,
  },
  directives: {
    Ripple,
  },
  props: {
    tempUserData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tahunOptions: [],
      jenisKelaminOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Jenis Kelamin --' },
        ],
      },
      jurusanOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Jurusan --' },
        ],
      },
      jenjangOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Jenjang --' },
        ],
      },
      peminatanOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Peminatan --' },
        ],
      },
      prodiOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Prodi --' },
        ],
      },
      provinsiOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Provinsi --' },
        ],
      },
      kotaOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Kota --' },
        ],
      },
      jurusanSMAOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Jurusan SMA --' },
          { value: 'IPA', title: 'IPA' },
          { value: 'IPS', title: 'IPS' },
          { value: 'Lainnya', title: 'Lainnya' },
        ],
      },
      programOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Program --' },
        ],
      },
      clevePhone: {
        phone: true,
        phoneRegionCode: 'ID',
      },
    }
  },
   beforeCreate() {
    //API data
      getJenisKelamin()
      .then(response => {
      if (response.data.length > 0) {
        response.data.forEach(element => {
          this.jenisKelaminOption.options.push({
            title: element.nama,
            value: element.uuid,
          })
        })
      }
      })
      .catch(error => console.log(error));

      getJurusan()
      .then(response => {
      if (response.data.length > 0) {
        response.data.forEach(element => {
          this.jurusanOption.options.push({
            title: element.nama,
            value: element.uuid,
          })
        })
      }
      })
      .catch(error => console.log(error));

      getJenjang()
      .then(response => {
      if (response.data.length > 0) {
        response.data.forEach(element => {
          this.jenjangOption.options.push({
            title: element.nama,
            value: element.uuid,
          })
        })
      }
      })
      .catch(error => console.log(error));

      getProdi()
      .then(response => {
      if (response.data.length > 0) {
        response.data.forEach(element => {
          this.prodiOption.options.push({
            title: element.nama,
            value: element.uuid,
          })
        })
      }
      })
      .catch(error => console.log(error));

      getPeminatan()
      .then(response => {
      if (response.data.length > 0) {
        response.data.forEach(element => {
          this.peminatanOption.options.push({
            title: element.nama,
            value: element.uuid,
          })
        })
      }
      })
      .catch(error => console.log(error));

      getProvinsi()
      .then(response => {
      if (response.data.length > 0) {
        var selected_provinsi_id = null
        response.data.forEach(element => {
          this.provinsiOption.options.push({
            title: element.nama,
            value: element.uuid,
          })
          selected_provinsi_id = element.selected_provinsi_id
        })
        if(selected_provinsi_id != null)
        {
          this.changeKota(selected_provinsi_id, true)
        }
      }
      })
      .catch(error => console.log(error));

      getProgram()
      .then(response => {
      if (response.data.length > 0) {
        response.data.forEach(element => {
          this.programOption.options.push({
            title: element.nama,
            value: element.uuid,
          })
        })
        this.success_check.push('success')
        this.completeCheck()
      }
      })
      .catch(error => {
      });

  },
  mounted() {
    this.populateYearOptions()
  },
  methods: {
    populateYearOptions() {
      const currentYear = new Date().getFullYear();
      const yearsToShow = 30; // Adjust this number as needed to show more or fewer years

      for (let i = currentYear; i >= currentYear - yearsToShow; i--) {
        this.tahunOptions.push({ value: i, title: i.toString() });
      }
    },
    async changeKota(provinsiId, onFirst = null) {
      this.kotaOption = {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Kota --' },
        ],
      }

      getKota(provinsiId)
      .then(response => {
      if (response.data.length > 0) {
        response.data.forEach(element => {
          this.kotaOption.options.push({
            title: element.nama,
            value: element.uuid,
          })
        })
      }
      })
      .catch(error => console.log(error));

      if(onFirst == null)
      {
        this.tempUserData.kota_id = null
      }
      
      
    },
    //Function
    async simpanData() {
      this.tempUserData.flag = 'info'
      const response = await ubahUserData(this.tempUserData)
      if (response.data.success === true) {
        this.makeToast('success', 'Data berhasil disimpan.')
      } else {
        this.makeToast('danger', response.data.message)
      }
    },
     makeToast(variant = null, message = null, title = null) {
      this.$bvToast.toast(message, {
        title: 'Pengaturan Akun',
        variant,
        solid: true,
        autoHideDelay: 10000,
        enableHtml: true,
        allowHtml: true,
      })
    },
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
